import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { Card, Text, Button, List } from 'react-native-paper';

export const Relatorios = () => {
  const [loading, setLoading] = React.useState(false);

  const handleGerarRelatorio = async (tipo: string) => {
    setLoading(true);
    try {
      // TODO: Implementar chamada à API de relatórios
      console.log(`Gerando relatório: ${tipo}`);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <ScrollView style={styles.container}>
      <Card style={styles.card}>
        <Card.Content>
          <Text variant="titleLarge">Relatórios Financeiros</Text>
          <List.Section>
            <List.Item
              title="Relatório de Cobranças"
              description="Resumo de todas as cobranças do período"
              left={props => <List.Icon {...props} icon="file-document" />}
              right={props => (
                <Button 
                  mode="contained" 
                  onPress={() => handleGerarRelatorio('cobrancas')}
                  loading={loading}
                >
                  Gerar
                </Button>
              )}
            />
            <List.Item
              title="Relatório de Inadimplência"
              description="Lista de clientes inadimplentes"
              left={props => <List.Icon {...props} icon="file-alert" />}
              right={props => (
                <Button 
                  mode="contained" 
                  onPress={() => handleGerarRelatorio('inadimplencia')}
                  loading={loading}
                >
                  Gerar
                </Button>
              )}
            />
          </List.Section>
        </Card.Content>
      </Card>

      <Card style={styles.card}>
        <Card.Content>
          <Text variant="titleLarge">Relatórios de Clientes</Text>
          <List.Section>
            <List.Item
              title="Score Médio"
              description="Análise do score médio dos clientes"
              left={props => <List.Icon {...props} icon="chart-bar" />}
              right={props => (
                <Button 
                  mode="contained" 
                  onPress={() => handleGerarRelatorio('score')}
                  loading={loading}
                >
                  Gerar
                </Button>
              )}
            />
            <List.Item
              title="Histórico de Consultas"
              description="Registro de todas as consultas realizadas"
              left={props => <List.Icon {...props} icon="history" />}
              right={props => (
                <Button 
                  mode="contained" 
                  onPress={() => handleGerarRelatorio('consultas')}
                  loading={loading}
                >
                  Gerar
                </Button>
              )}
            />
          </List.Section>
        </Card.Content>
      </Card>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    padding: 16,
  },
  card: {
    marginBottom: 16,
  },
});
